import { API_URL } from "constants/config";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuthTokens } from "modules/auth";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { io, Socket } from "socket.io-client";

export const useSocket = ({
  pathName,
  onConnectEmitEvents
}: {
  pathName: string;
  onConnectEmitEvents: string[];
}) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  const { accessToken } = useAuthTokens();

  const connectToSocketChannel = async () => {
    if (accessToken) {
      const baseUrl = API_URL.replace(/\/+$/, "");
      const namespace = pathName.replace(/^\/+/, "");
      setSocket(
        io(`${baseUrl}/${namespace}`, {
          extraHeaders: {
            Authorization: `Bearer ${accessToken}`
          },
          auth: {
            Authorization: `Bearer ${accessToken}`
          }
        })
      );
    }
  };

  const closeSocketChanel = () => {
    if (socket) {
      socket.close();
      setSocket(null);
    }
  };

  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        onConnectEmitEvents.forEach((event) => {
          socket.emit(event);
        });

        setIsConnected(true);
      });

      socket.on("disconnect", (_e) => {
        setIsConnected(false);
      });

      socket.on("error", () => {
        toast.error("Catched some error in socket");
      });
    }
  }, [socket]);

  useEffect(() => {
    if (accessToken) {
      connectToSocketChannel();
    } else {
      closeSocketChanel();
    }

    return () => {
      closeSocketChanel();
    };
  }, [accessToken]);

  return {
    socket,
    isConnected
  };
};
